import React, { useState, useEffect } from "react";
import db from "../../firebase";  
import { useParams, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import Divider from '@material-ui/core/Divider';

const EditAuthor = () => {
    let history = useHistory();
    const { authorName } = useParams();
    const [docId , setDocId ] = useState("");
    // Set initial values of the fields
    const [name, setName] = useState("");
    const [designation, setDesignation] = useState("");
    const [profilePic, setProfilePic] = useState("");
    const [institution, setInstitution] = useState("");
    // Get the Author document by matching the name
    // useEffect is used here to stop loading database on every render, it'll load only once, when the page loads
    useEffect (() => {
        db.collection("authors").where("name", "==", authorName).get().then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
                let author = {};
                author = doc.data();
                setName(author.name);
                setDesignation(author.designation);
                setProfilePic(author.dpSrc);
                setInstitution(author.institution);
                setDocId(querySnapshot.docs[0].id);
            })
        })
    }, [ authorName ])
    const handleSubmit = async(event) => {
        event.preventDefault();
        const author = { 
            name: name, 
            designation: designation, 
            dpSrc: profilePic, 
            institution: institution,
        };
        await db.collection("authors").doc(docId).update(author);
        console.log("data updated");
        history.push("/admin/posts");
    }

    return (
        <Grid>
            <h1>Edit Post page</h1>
            {/* Edit the Post */}
            <form className="container" onSubmit={handleSubmit}>
                {/* Name */}
                <TextField 
                    fullWidth id="name"
                    label="name" 
                    variant="filled" 
                    value={name} 
                    onChange={(event) => setName(event.target.value)} 
                    helperText="Enter the Name of the Author"
                />
                {/* Designation */}
                <TextField
                    fullWidth
                    id="designation"
                    label="designation"
                    variant="filled"
                    value={designation}
                    onChange={(event) => (setDesignation(event.target.value))}
                    helperText="Enter the designation of the post"
                />
                {/* Profile picture */}
                <TextField fullWidth id="profilePic" label="Featured Image" variant="filled" value={profilePic} onChange={(event) => setProfilePic(event.target.value)} helperText="Enter the link of the image" />
                <img src= {profilePic} alt="" />
                {/* Institution */}
                <TextField multiline fullWidth id="filled-basic" label="institution" variant="filled" value={institution} onChange={(event) => setInstitution(event.target.value)} rows={50} helperText="Enter the post in html format (without the <head> and <body> tags, just the <p> <img> and other tags)" />
                {/* Submit button */}
                <Divider />
                <Button type="submit" endIcon={<SendIcon />} variant="outlined">
                    Update
                </Button>
            </form>
        </Grid>
    );
}

export default EditAuthor;